/**
 * =========================================================
 * Shopify Horizon AOS
 * Native IntersectionObserver
 * =========================================================
 */

(function () {

  'use strict';

  const AOS_CONFIG = {

    offset: 100,

    once: true,

    rootMargin: '0px 0px -100px 0px'

  };

  function initAOS(container = document) {

    const elements = container.querySelectorAll(
      '[data-aos]:not([data-aos-ready])'
    );


    if (!elements.length) {

      console.log('[AOS] No elements found.');

      return;

    }


    console.log(
      '[AOS] Initializing:',
      elements.length,
      'elements'
    );


    /* =====================================================
       IntersectionObserver
       ===================================================== */

    const observer = new IntersectionObserver(

      function (entries) {

        entries.forEach(function (entry) {

          const element = entry.target;


          if (entry.isIntersecting) {

            element.classList.add('aos-animate');


            console.log(
              '[AOS] Animate:',
              element
            );


            if (AOS_CONFIG.once) {

              observer.unobserve(element);

            }

          } else {

            if (!AOS_CONFIG.once) {

              element.classList.remove(
                'aos-animate'
              );

            }

          }

        });

      },

      {
        root: null,

        rootMargin: AOS_CONFIG.rootMargin,

        threshold: 0.01

      }

    );


    elements.forEach(function (element) {

      element.setAttribute(
        'data-aos-ready',
        'true'
      );


      observer.observe(element);

    });

    window.ShopifyAOSObserver = observer;

  }


  function ready() {

    console.log(
      '[AOS] Shopify AOS loaded.'
    );


    initAOS();

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      ready
    );

  } else {

    ready();

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      console.log(
        '[AOS] Section loaded.'
      );


      initAOS(
        event.target
      );

    }
  );


  /* =======================================================
     Shopify Section Reorder
     ======================================================= */

  document.addEventListener(
    'shopify:section:reorder',
    function () {

      initAOS();

    }
  );


  /* =======================================================
     Shopify Section Select
     ======================================================= */

  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initAOS(
        event.target
      );

    }
  );


  /* =======================================================
     Shopify Section Deselect
     ======================================================= */

  document.addEventListener(
    'shopify:section:deselect',
    function () {

      initAOS();

    }
  );


  window.ShopifyAOS = {

    init: initAOS,

    refresh: function () {

      initAOS();

    }

  };


})();